module.exports = __webpack_public_path__ + "img/icon_left@2x.1b07f7cf.png";